export function setDynamicCanonical() {
  let canonicalElem = document.querySelector<HTMLLinkElement>("[data-canonical-link]");

  // Create canonical link element if not present
  if (!canonicalElem) {
    canonicalElem = document.createElement("link");
    canonicalElem.rel = "canonical";
    canonicalElem.setAttribute("data-canonical-link", "");
    document.head.appendChild(canonicalElem);
  }

  const rawPathname = window.location.pathname;
  let normalizedPathname = rawPathname.replace(/\/\/{2,}/g, '/').toLowerCase().trim();

  // Remove trailing slash for non-root URLs
  if (normalizedPathname !== '/' && normalizedPathname.endsWith('/')) {
    normalizedPathname = normalizedPathname.replace(/\/+$/, '');
  }

  if (normalizedPathname === '/index' || normalizedPathname === '/index.html' || normalizedPathname === '/index.php') {
    normalizedPathname = '/our-products';
  }

  const canonicalUrl = "https://intronlifesciences.com" + normalizedPathname;
  canonicalElem.href = canonicalUrl;

  console.log('Canonical tag set to:', canonicalUrl);
}
